module.exports = __webpack_public_path__ + "static/media/SourceSans-Regular.fdc03546.woff";